var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container"},[_c('h2',{staticClass:"tab-title"},[_vm._v(_vm._s(_vm.title))]),_c('el-row',[_c('GenericTable',{attrs:{"tableProps":_vm.initialBalanceTableProps,"tableData":_vm.info.openingBalance},on:{"comment":_vm.handleComment}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }